var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackButtonCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 19.75,
    stroke: "#DADADA",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20.5002C29 20.9206 28.7093 21.268 28.3321 21.323L28.2273 21.3306L12.7727 21.3306C12.346 21.3306 12 20.9588 12 20.5002C12 20.0799 12.2907 19.7325 12.6679 19.6775L12.7727 19.6699L28.2273 19.6699C28.654 19.6699 29 20.0417 29 20.5002Z",
    fill: "#230B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5512 26.5813C19.8537 26.9049 19.8547 27.4306 19.5536 27.7555C19.2799 28.051 18.8506 28.0787 18.5476 27.8383L18.4608 27.7581L12.2275 21.0889C11.9517 20.7939 11.9266 20.331 12.1522 20.0055L12.2274 19.9122L18.4608 13.242C18.7631 12.9184 19.2524 12.9195 19.5536 13.2444C19.8273 13.5398 19.8514 14.0011 19.6263 14.3257L19.5513 14.4187L13.8681 20.5009L19.5512 26.5813Z",
    fill: "#230B34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButtonCircleIcon);
export default __webpack_public_path__ + "static/media/back-button-circle-icon.33bde0d70c09a94c7d7937a6af4251f6.svg";
export { ForwardRef as ReactComponent };